import { GST_RATE } from './constants';

export const round = (val: number, places: number = 2) : number => {
    const c = Math.pow(10, places);
    const m = Number((Math.abs(val) * c).toPrecision(15));
    return Math.round(m) / c * Math.sign(val);
}

/** Rounds using "half away from zero" - matches C# MidpointRounding.AwayFromZero for backend/Attache consistency (avoids Access Financials allocation mismatches). */
export const roundAwayFromZero = (val: number, places: number = 2): number => {
    const factor = Math.pow(10, places);
    const m = Number((Math.abs(val) * factor).toPrecision(15));
    return Math.sign(val) * Math.round(m) / factor;
};

/** GST on a subtotal using away-from-zero rounding (for fuel levy etc - matches backend/Attache). */
export const roundAwayFromZeroGst = (unroundedSubtotal: number): number => {
    return roundAwayFromZero(unroundedSubtotal * GST_RATE);
};

export const roundedGst = (unroundedSubtotal: number): number => {
    return round(unroundedSubtotal * GST_RATE);
}

export const roundedTotal = (unroundedSubtotal: number): number => {
    return (round(unroundedSubtotal + roundedGst(unroundedSubtotal)));
}

export const roundedSubtotal = (unroundedSubtotal: number): number => {
    return roundedTotal(unroundedSubtotal) - roundedGst(unroundedSubtotal);
}

export const parseAsCurrency = (s: string): number => {
    const num = Number(s);
    return Number.isNaN(num) ? 0.00 : (Math.floor(num * 100) / 100);
}